import { Check, Circle } from "lucide-react";

import { Button } from "@/components/base/button";

export function CheckInButton({
  checkIn,
  playerProfileId,
  toggleCheckIn,
}: {
  checkIn: { method: string; createdAt: Date | null } | undefined;
  playerProfileId: number;
  toggleCheckIn: (playerProfileId: number) => void;
}) {
  const isCheckedIn = checkIn != null;

  return (
    <Button
      variant="icon"
      size="sm"
      className={
        isCheckedIn
          ? "mr-1.5 border-green-300 bg-green-100 text-green-700 hover:border-green-400 hover:bg-green-200"
          : "mr-1.5 border-gray-300 bg-transparent text-gray-400 hover:border-gray-400 hover:bg-gray-100"
      }
      tooltip={isCheckedIn ? "Checked in — click to undo" : "Click to check in"}
      onPress={() => toggleCheckIn(playerProfileId)}
    >
      {isCheckedIn ? <Check /> : <Circle />}
    </Button>
  );
}
